import type { FloorGeometry } from './types'

const MAX_HISTORY = 40

export function cloneGeometry(g: FloorGeometry): FloorGeometry {
  return JSON.parse(JSON.stringify(g)) as FloorGeometry
}

export type GeometryHistoryState = {
  past: FloorGeometry[]
  future: FloorGeometry[]
}

export function createHistoryState(): GeometryHistoryState {
  return { past: [], future: [] }
}

export function pushHistory(
  state: GeometryHistoryState,
  current: FloorGeometry,
  next: FloorGeometry,
): GeometryHistoryState {
  const past = [...state.past, cloneGeometry(current)].slice(-MAX_HISTORY)
  return { past, future: [] }
}

export function undoHistory(
  state: GeometryHistoryState,
  current: FloorGeometry,
): { state: GeometryHistoryState; geometry: FloorGeometry | null } {
  if (state.past.length === 0) return { state, geometry: null }
  const past = [...state.past]
  const previous = past.pop()!
  const future = [cloneGeometry(current), ...state.future].slice(0, MAX_HISTORY)
  return { state: { past, future }, geometry: previous }
}

export function redoHistory(
  state: GeometryHistoryState,
  current: FloorGeometry,
): { state: GeometryHistoryState; geometry: FloorGeometry | null } {
  if (state.future.length === 0) return { state, geometry: null }
  const future = [...state.future]
  const next = future.shift()!
  const past = [...state.past, cloneGeometry(current)].slice(-MAX_HISTORY)
  return { state: { past, future }, geometry: next }
}

export function resetHistory(): GeometryHistoryState {
  return { past: [], future: [] }
}
